import { Hero } from "@/components/home/Hero";
import { EventStrip } from "@/components/home/EventStrip";
import { PathsGrid } from "@/components/home/PathsGrid";
import { CtaBand } from "@/components/home/CtaBand";

export default function HomePage() {
  return (
    <>
      <Hero />
      <EventStrip />
      <PathsGrid />
      <CtaBand />
    </>
  );
}
